const getPreviousAppcuesID = (): string | null | undefined => {
  try {
    // Note: localStorage is undefined in browsers that do not support it
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return localStorage?.getItem("apc_user_id")
  } catch {
    return null
  }
}

// If we don't introduce this function scope here, TS thinks that the variables
// declared below are globals accessible in other files.
;(function () {
  window.AppcuesSettings = { enableURLDetection: true }
  const script = document.createElement("script")
  script.type = "text/javascript"
  script.src = "https://fast.appcues.com/134781.js"
  script.onload = () => {
    const email = document.body.getAttribute("data-email")
    const userID = document.body.getAttribute("data-id")
    const accountID = document.body.getAttribute("data-account-id")

    const currentAppCuesID =
      email ?? userID ?? getPreviousAppcuesID() ?? "anonymous"

    const userProperties = {
      Anonymous: currentAppCuesID === "anonymous",
      email,
      "Orum User ID": userID,
      "Org Name": document.body.getAttribute("data-org-name"),
      CRM: document.body.getAttribute("data-integration-type"),
      "Org Package": document.body.getAttribute("data-package"),
      "User Access Level": document.body.getAttribute("data-access-level"),
      "User License Type": document.body.getAttribute("data-license"),
      "Org Created Date": document.body.getAttribute("data-created-date"),
      "Org Paid": document.body.getAttribute("data-paid"),
      "Org Countries Enabled For Dialing": document.body.getAttribute(
        "data-countries-dialing-enabled",
      ),
      "Org Domestic Recording Enabled": document.body.getAttribute(
        "data-domestic-recording-enabled",
      ),
      "Org International Recording Enabled": document.body.getAttribute(
        "data-international-recording-enabled",
      ),
      "Org Parallel Dialing": document.body.getAttribute(
        "data-parallel-dialing-enabled",
      ),
      "Org Data Enrichment Enabled": document.body.getAttribute(
        "data-enrichment-enabled",
      ),
      "Org Public Recording Links Enabled": document.body.getAttribute(
        "data-public-recording-links-enabled",
      ),
      "Org Gong Integration Enabled": document.body.getAttribute(
        "data-gong-integration-enabled",
      ),
      "Org AI Coaching Enabled": document.body.getAttribute(
        "data-ai-coaching-enabled",
      ),
      "User AI Roleplay Enabled": document.body.getAttribute(
        "data-ai-roleplay-enabled",
      ),
      ...(accountID !== null && { account_id: accountID }),
    } satisfies Record<string, unknown>

    window.Appcues?.identify(currentAppCuesID, userProperties)
  }
  document.head.appendChild(script)
})()
